import { Compatibility, SceneObject } from '@cgs/wge';
import { PopupResizeFunction } from './popup.resize';

interface PopupOrientationParams {
  modesId?: string;
  horizontalState?: string;
  verticalState?: string;
}

export function buildPopupOrientationFunction(params?: PopupOrientationParams): PopupResizeFunction {
  const modesId = params?.modesId ?? 'Modes';
  const horizontalState = params?.horizontalState ?? 'horizontal';
  const verticalState = params?.verticalState ?? 'vertical';

  return (popupScene: SceneObject): void => {
    const state = Compatibility.isPortrait ? verticalState : horizontalState;
    popupScene.findById(modesId)?.stateMachine?.switchToState(state);
  };
}

export const popupOrientationFunction = buildPopupOrientationFunction();
